import { getResetBtnSettingsToCSS } from '@Blocks/_lib/btns';

import { __Front } from '@/src/Views/Shared/lib';
import { ResetBtn } from '@Views/Shared/Button/ResetBtn';

import type { FiltersCpts } from '../Search';
import Filter from './Filter';

declare const pll_activated: boolean;

export const Filters = (props: FiltersCpts) => {
	const { cpts, setSelectedCpts, selectedCpts, resetButtonStyle, pageSearch, labels } = props;

	const CptsFilter = {
		terms: cpts,
		noResultLabel:
			labels?.notFound && !pll_activated
				? labels?.notFound
				: __Front('front.filters.no_content_type_found'),
		searchLabel:
			labels?.filter && !pll_activated
				? labels?.filter
				: __Front('front.filters.search_for_content_types'),
		selectLabel:
			labels?.filter && !pll_activated
				? labels?.filter
				: __Front('front.filters.select_a_content_type'),
		setValue: setSelectedCpts,
		value: selectedCpts,
		selectClass:
			'minos-search-filters-font-style bg-minos-search-filters-bg-color border-minos-search-filters-border-width  border-minos-search-filters-border-color rounded-minos-search-filters-radius',
		actifClass: 'bg-minos-search-filters-actif-color',
	};

	return (
		<div
			className={`my-4 tablet:ml-auto ${pageSearch?.headingVariant != 'leftInline' ? 'block text-center tablet:flex tablet:flex-wrap tablet:items-center tablet:gap-4 ' : 'flex flex-wrap items-center gap-4'}`}
		>
			<div className='z-20 w-full tablet:w-fit'>
				<Filter {...CptsFilter} />
			</div>
			{selectedCpts && (
				<div
					className={`w-full tablet:w-fit ${pageSearch?.headingVariant != 'leftInline' && 'mt-4 tablet:mt-0'}`}
				>
					<ResetBtn
						btnHasIcon={resetButtonStyle?.btnHasIcon}
						btnDecorationElement={resetButtonStyle?.btnDecorationElement}
						animation={resetButtonStyle?.animation}
						btnClassName={getResetBtnSettingsToCSS(resetButtonStyle, 'search')}
						resetSelected={() => {
							setSelectedCpts('');
						}}
					/>
				</div>
			)}
		</div>
	);
};
